import { defineComponent as o } from "vue";
import "./PlatinumMemberBox.css";
const i = o({
  name: "PlatinumMemberBox",
  props: {
    customerMVPInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    GetShowType() {
      let e = 0;
      const t = this.customerMVPInfo;
      return t == null ? 0 : (t.isLogined && t.isMVP ? e = 3 : t.isGetFreeTrailMVP ? e = 2 : e = 1, e);
    }
  }
});
export {
  i as default
};
